import {Tag} from 'api/types/tagTypes';
import {v4 as uuidv4} from 'uuid';

import {WisbitActionTypes, Bit, Component, Wisbit} from '../types';

// Wisbit loading

export const SAVE_WISBIT_REQUEST = 'WisbitPage/SAVE_WISBIT_REQUEST';
export const SAVE_WISBIT_SUCCESS = 'WisbitPage/SAVE_WISBIT_SUCCESS';
export const SAVE_WISBIT_FAILURE = 'WisbitPage/SAVE_WISBIT_FAILURE';

export const LOAD_TAGS_REQUEST = 'WisbitPage/LOAD_TAGS_REQUEST';
export const LOAD_TAGS_SUCCESS = 'WisbitPage/LOAD_TAGS_SUCCESS';
export const LOAD_TAGS_FAILURE = 'WisbitPage/LOAD_TAGS_FAILURE';

// Wisbit editing

export const LOAD_WISBIT_REQUEST = 'WisbitPage/LOAD_WISBIT_REQUEST';
export const LOAD_WISBIT_SUCCESS = 'WisbitPage/LOAD_WISBIT_SUCCESS';
export const LOAD_WISBIT_FAILURE = 'WisbitPage/LOAD_WISBIT_FAILURE';

export const PUBLISH_WISBIT_REQUEST = 'WisbitPage/PUBLISH_WISBIT_REQUEST';
export const PUBLISH_WISBIT_SUCCESS = 'WisbitPage/PUBLISH_WISBIT_SUCCESS';
export const PUBLISH_WISBIT_FAILURE = 'WisbitPage/PUBLISH_WISBIT_FAILURE';

export const DELETE_WISBIT_REQUEST = 'WisbitPage/DELETE_WISBIT_REQUEST';
export const DELETE_WISBIT_SUCCESS = 'WisbitPage/DELETE_WISBIT_SUCCESS';
export const DELETE_WISBIT_FAILURE = 'WisbitPage/DELETE_WISBIT_FAILURE';

export const INITIATE_WISBIT = 'WisbitPage/INITIATE_WISBIT';

// General information editing

export const CHANGE_TITLE = 'WisbitPage/CHANGE_TITLE';
export const CHANGE_DESCRIPTION = 'WisbitPage/CHANGE_DESCRIPTION';
export const CHANGE_DATE = 'WisbitPage/CHANGE_DATE';
export const CHANGE_TAGS = 'WisbitPage/CHANGE_TAGS';
export const CHANGE_THUMBNAIL = 'WisbitPage/CHANGE_THUMBNAIL';

// Bit editing

export const CREATE_BIT = 'WisbitPage/CREATE_BIT';
export const DELETE_BIT = 'WisbitPage/DELETE_BIT';
export const UPDATE_BIT_TITLE = 'WisbitPage/UPDATE_BIT_TITLE';
export const UPDATE_BIT_DURATION = 'WisbitPage/UPDATE_BIT_DURATION';
export const CREATE_BIT_COMPONENT = 'WisbitPage/CREATE_BIT_COMPONENT';
export const DELETE_BIT_COMPONENT = 'WisbitPage/DELETE_BIT_COMPONENT';
export const UPDATE_BIT_COMPONENT = 'WisbitPage/UPDATE_BIT_COMPONENT';
export const MOVE_BIT = 'WisbitPage/MOVE_BIT';

export const CLEAR_LOADING = 'WisbitPage/CLEAR_LOADING';

export const UPDATE_TAGS = 'WisbitPage/UPDATE_TAGS';

export function saveWisbitRequest(): WisbitActionTypes {
  return {
    type: SAVE_WISBIT_REQUEST,
    payload: {},
  };
}

export function saveWisbitSuccess(wisbit: Wisbit): WisbitActionTypes {
  return {
    type: SAVE_WISBIT_SUCCESS,
    payload: {
      ...wisbit,
      error: undefined,
    },
  };
}

export function saveWisbitFailure(error: Error): WisbitActionTypes {
  return {
    type: SAVE_WISBIT_FAILURE,
    payload: {
      error,
    },
  };
}

export function loadTagsRequest(): WisbitActionTypes {
  return {
    type: LOAD_TAGS_REQUEST,
    payload: {},
  };
}

export function loadTagsSuccess(allTags: string[]): WisbitActionTypes {
  return {
    type: LOAD_TAGS_SUCCESS,
    payload: {
      allTags,
    },
  };
}

export function loadTagsFailure(error: Error): WisbitActionTypes {
  return {
    type: LOAD_TAGS_FAILURE,
    payload: {
      error,
    },
  };
}

export function loadWisbitRequest(id: string): WisbitActionTypes {
  return {
    type: LOAD_WISBIT_REQUEST,
    payload: {
      id,
    },
  };
}

export function loadWisbitSuccess(wisbit: Wisbit): WisbitActionTypes {
  return {
    type: LOAD_WISBIT_SUCCESS,
    payload: {
      ...wisbit,
    },
  };
}

export function loadWisbitFailure(error: Error): WisbitActionTypes {
  return {
    type: LOAD_WISBIT_FAILURE,
    payload: {
      error,
    },
  };
}

export function publishWisbitRequest(): WisbitActionTypes {
  return {
    type: PUBLISH_WISBIT_REQUEST,
    payload: {},
  };
}

export function publishWisbitSuccess(): WisbitActionTypes {
  return {
    type: PUBLISH_WISBIT_SUCCESS,
    payload: {},
  };
}

export function publishWisbitFailure(error: Error): WisbitActionTypes {
  return {
    type: PUBLISH_WISBIT_FAILURE,
    payload: {
      error,
    },
  };
}

export function deleteWisbitRequest(): WisbitActionTypes {
  return {
    type: DELETE_WISBIT_REQUEST,
    payload: {},
  };
}

export function deleteWisbitSuccess(): WisbitActionTypes {
  return {
    type: DELETE_WISBIT_SUCCESS,
    payload: {},
  };
}

export function deleteWisbitFailure(error: Error): WisbitActionTypes {
  return {
    type: DELETE_WISBIT_FAILURE,
    payload: {
      error,
    },
  };
}

export function initiateWisbit(
  bits?: Bit[],
  template?: string,
  loading?: boolean
): WisbitActionTypes {
  return {
    type: INITIATE_WISBIT,
    payload: {
      loading,
      template,
      bits,
    },
  };
}

export function changeTitle(title: string): WisbitActionTypes {
  return {
    type: CHANGE_TITLE,
    payload: {
      title,
    },
  };
}

export function changeDescription(description: string): WisbitActionTypes {
  return {
    type: CHANGE_DESCRIPTION,
    payload: {
      description,
    },
  };
}

export function changeDate(date: string): WisbitActionTypes {
  return {
    type: CHANGE_DATE,
    payload: {
      date,
    },
  };
}

export function changeTags(tags: Tag[]): WisbitActionTypes {
  return {
    type: CHANGE_TAGS,
    payload: {
      tags,
    },
  };
}

export function changeThumbnail(imageId?: string): WisbitActionTypes {
  return {
    type: CHANGE_THUMBNAIL,
    payload: {
      thumbnailId: imageId,
    },
  };
}

export function createBit(): WisbitActionTypes {
  return {
    type: CREATE_BIT,
    payload: {selectedBit: {id: uuidv4(), title: '', duration: undefined}},
  };
}

export function deleteBit(selectedId: string): WisbitActionTypes {
  return {
    type: DELETE_BIT,
    payload: {
      selectedBit: {id: selectedId},
    },
  };
}

export function updateBitTitle(id: string, title: string): WisbitActionTypes {
  return {
    type: UPDATE_BIT_TITLE,
    payload: {
      selectedBit: {id, title},
    },
  };
}

export function updateBitDuration(
  id: string,
  duration: number
): WisbitActionTypes {
  return {
    type: UPDATE_BIT_DURATION,
    payload: {
      selectedBit: {id, duration},
    },
  };
}

export function createBitComponent(
  id: string,
  newComponent: Partial<Component>
): WisbitActionTypes {
  return {
    type: CREATE_BIT_COMPONENT,
    payload: {
      selectedBit: {id, selectedComponent: {id: uuidv4(), ...newComponent}},
    },
  };
}

export function deleteBitComponent(
  id: string,
  componentId: string
): WisbitActionTypes {
  return {
    type: DELETE_BIT_COMPONENT,
    payload: {
      selectedBit: {id, selectedComponent: {id: componentId}},
    },
  };
}

export function updateBitComponent(
  id: string,
  selectedComponent: Component
): WisbitActionTypes {
  return {
    type: UPDATE_BIT_COMPONENT,
    payload: {
      selectedBit: {id, selectedComponent},
    },
  };
}

export function moveBit(bits: Bit[]): WisbitActionTypes {
  return {
    type: MOVE_BIT,
    payload: {
      bits,
    },
  };
}

export function clearLoading(): WisbitActionTypes {
  return {
    type: CLEAR_LOADING,
    payload: {},
  };
}

export function updateTags(newTags: string[]) {
  return {
    type: UPDATE_TAGS,
    payload: {
      tags: newTags,
    },
  };
}
